/**
 * Конфигурация табов для главной страницы
 */

import type { HomeTabId } from '@/lib';

export interface HomeTab {
  id: HomeTabId;
  labelKey: string;
}

export const HOME_TABS: HomeTab[] = [
  { id: 'feed', labelKey: 'home:home.tabs.feed' },
  { id: 'selections', labelKey: 'home:home.tabs.collections' },
  { id: 'popular', labelKey: 'home:home.tabs.popular' },
  { id: 'wishlists', labelKey: 'common:wishlists' },
] as const;